/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsidHospital from './HospitalsidHospital';

/**
 * The SurgeryTypesIdBody model module.
 * @module model/SurgeryTypesIdBody
 * @version v0.3
 */
export default class SurgeryTypesIdBody {
  /**
   * Constructs a new <code>SurgeryTypesIdBody</code>.
   * @alias module:model/SurgeryTypesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurgeryTypesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurgeryTypesIdBody} obj Optional instance to populate.
   * @return {module:model/SurgeryTypesIdBody} The populated <code>SurgeryTypesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurgeryTypesIdBody();
      if (data.hasOwnProperty('surgery_type'))
        obj.surgeryType = HospitalsidHospital.constructFromObject(data['surgery_type']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsidHospital} surgeryType
 */
SurgeryTypesIdBody.prototype.surgeryType = undefined;

